export default __webpack_public_path__ + "static/media/logo-oficina-06-percent.d6b1e1c9.png";